import type { PropsWithChildren } from 'react'
import { createContext, useEffect, useRef } from 'react'
import type { StoreApi } from 'zustand'

import { getQueryClient } from '../services/queryClient'
import { appStore, INITIAL_STATE } from '../store'
import type { AppState } from '../store/types'

export const AppStoreContext = createContext<StoreApi<AppState> | null>(null)

export const AppStoreProvider = ({ children }: PropsWithChildren<{}>) => {
  const storeRef = useRef<typeof appStore>()

  if (!storeRef.current) {
    storeRef.current = appStore
  }

  // resets the store when the component unmounts
  useEffect(() => {
    return () => {
      storeRef.current?.setState(INITIAL_STATE)
      // clears the query client just in case
      getQueryClient().clear()
    }
  }, [])

  return (
    <AppStoreContext.Provider value={storeRef.current}>
      {children}
    </AppStoreContext.Provider>
  )
}
